require("angular-i18n/en");

angular
    .module("Agnes")
    //
    .config([
        "$translateProvider",
        function (translateProvider) {
            translateProvider
                .translations("en", require("../Translations/en.json"))
                .preferredLanguage("en");
        }
    ]);